import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward"
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward"
import PropTypes from "prop-types"
import { useCallback } from "react"

const NewSort = ({ options, sort, setSort, data }) => {
  const getSortIcon = (name) => {
    if (name === sort.name) {
      return sort.direction === "ASC" ? (
        <ArrowUpwardIcon className="h-5 w-5" />
      ) : (
        <ArrowDownwardIcon className="h-5 w-5" />
      )
    }
    return <div className="h-5 w-5" />
  }

  const changeSort = useCallback(
    (option) => {
      setSort((prevSort) => {
        let newDirection = "ASC"
        if (prevSort.name === option.id) {
          newDirection = prevSort.direction === "ASC" ? "DSC" : ""
        }
        return {
          name: newDirection !== "" ? option.id : "",
          direction: newDirection,
        }
      })
    },
    [setSort, sort],
  )
  if (data.length === 0) return null

  return (
    <div className="flex gap-8 mr-16">
      {options.map((option) => {
        return (
          <button
            key={option.id}
            className="uppercase text-brand-secondary text-[14px] cursor-pointer flex items-center"
            onClick={() => changeSort(option)}
          >
            {option.label} {getSortIcon(option.id)}
          </button>
        )
      })}
    </div>
  )
}

NewSort.propTypes = {
  options: PropTypes.array,
  sort: PropTypes.object,
  setSort: PropTypes.func,
  data: PropTypes.array,
}

export default NewSort
